export default __webpack_public_path__ + "static/media/ic_sent.1503eea1.svg";